module.exports = __webpack_public_path__ + "img/paste.f26bc9b5.svg";